<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';

const props = defineProps<{
  text: string;
  targetRef: HTMLElement | null;
}>();

const isVisible = ref(false);
const tooltipRef = ref<HTMLElement | null>(null);
const position = ref({ top: 0, left: 0 });

const updatePosition = () => {
  if (!props.targetRef || !tooltipRef.value) return;
  
  const targetRect = props.targetRef.getBoundingClientRect();
  const tooltipRect = tooltipRef.value.getBoundingClientRect();
  
  position.value = {
    top: targetRect.top - tooltipRect.height - 8, // 8px above
    left: targetRect.right + 8, // 8px to the right of the element
  };
};

const show = () => {
  isVisible.value = true;
  setTimeout(updatePosition, 0); // Wait for DOM update
};

const hide = () => {
  isVisible.value = false;
};

defineExpose({ show, hide });

const tooltipStyle = computed(() => ({
  top: `${position.value.top}px`,
  left: `${position.value.left}px`,
}));
</script>

<template>
  <Teleport to="body">
    <div
      v-if="isVisible"
      ref="tooltipRef"
      role="tooltip"
      :style="tooltipStyle"
      class="fixed z-[9999] pointer-events-none transition-opacity duration-200 ease-in-out"
      :class="isVisible ? 'opacity-100' : 'opacity-0'"
    >
      <div
        class="px-3 py-2 text-xs font-semibold text-[#1e3a8a] bg-[#fde8f3]/20 border border-[#c026d3] rounded shadow-lg backdrop-blur-sm max-w-[180px] leading-relaxed"
      >
        {{ text }}
      </div>
    </div>
  </Teleport>
</template>
